"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Locale = void 0;
var nested_locale_1 = require("../nested-locale/nested-locale");
var string_format_1 = require("../string-format/string-format");
var Locale = /** @class */function () {
  function Locale(entry) {
    this.nestedResources = {};
    var language = entry.language,
      localeObject = entry.localeObject;
    this.resources = localeObject[language];
  }
  Locale.prototype.translate = function (key, stringFormatData) {
    var resources = this.resources;
    var _a = resources,
      _b = key,
      value = _a[_b];
    if (typeof value === 'string') {
      var stringFormat = new string_format_1.StringFormat();
      return stringFormat.format(value, stringFormatData);
    }
    return JSON.stringify(value) || key;
  };
  Locale.prototype.getCollection = function (chain) {
    var nestedResources = this.getNestedObject(chain);
    return new nested_locale_1.NestedLocale(nestedResources);
  };
  Locale.prototype.getNestedObject = function (chain) {
    if (!this.nestedResources[chain]) {
      var splitChain = chain.split('.');
      var resources_1 = this.resources;
      splitChain.forEach(function (value) {
        var nestedResources = resources_1[value];
        if (typeof nestedResources === 'object') {
          resources_1 = nestedResources;
        } else {
          throw new Error('The value of your requested chain is not an object');
        }
      });
      this.nestedResources[chain] = resources_1;
    }
    return this.nestedResources[chain];
  };
  return Locale;
}();
exports.Locale = Locale;